module.exports = __webpack_public_path__ + "img/tab4.aeda9a07.png";